import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Make a container act like a link without wrapping it in an <a>
// (which would conflict with nested links/buttons inside the row).
// A click anywhere in the container navigates, *unless* the click
// landed on an inner interactive element — in that case the inner
// element handles its own click and we stay put.
//
// Usage:
//   <div data-controller="row-link"
//        data-action="click->row-link#navigate"
//        data-row-link-url-value="/path"
//        data-row-link-frame-value="drawer_container">  <!-- optional -->
//     … content with arbitrary <a>/<button> inside …
//   </div>
//
// frame-value is optional; without it, navigation goes top-level.
export default class extends Controller {
  static values = { url: String, frame: { type: String, default: "" } }

  navigate(event) {
    // Let inner interactive elements (the chevron link, ticket badge,
    // form buttons, etc.) handle their own clicks.
    const interactive = event.target.closest("a, button, input, select, textarea, label")
    if (interactive && interactive !== this.element) return

    if (this.frameValue) {
      const frame = document.getElementById(this.frameValue)
      if (frame) {
        frame.src = this.urlValue
        return
      }
    }
    Turbo.visit(this.urlValue)
  }
}
